import { FCreneaux } from './FCreneaux';

export class WeekCreneauxLibre {
    
    creneaux:FCreneaux[];
    date: Date;
  
   

    constructor(date:Date, creneaux:FCreneaux[]){
 
        this.date = date;
        this.creneaux = creneaux;

   }

   public static fromJson(json: Object): WeekCreneauxLibre {
        
    return new WeekCreneauxLibre(
        json['date'],
        json['creneaux']
        )
    }
  }